import {
  SET_STORE_SELECTED_MERCHANT_PRODUCT,
  SET_STORE_CART_SELECT_MERCHATS_ZONE,
  SET_STORE_MOBILE_APP_CATEGORY,
  SET_STORE_CART_CHECKOUT_DATA,
  SET_STORE_MOBILE_SETTINGS,
} from "../../database/store-data";
import {
  dto_selected_final_merchant_or_product,
  dto_selected_merchant_or_product,
} from "../dto-selected-merchant-or-product";
import { dto_StartupPageLoadInfo } from "../dto-mobile-settings";
import { dto_MobileAppCategory } from "../dto-mobile-app-category";
import { dto_cart_checkout } from "../dto-cart-checkout";
import { dto_Merchant } from "../dto-merchant";
import { dto_common } from "../dto-common";

//#region dto-Merchant
export const set_dto_Merchant = async (data) => {
  dto_Merchant.MID = data.MID;
  dto_Merchant.Merchant = data.Merchant;
  dto_Merchant.Add1 = data.Add1;
  dto_Merchant.Add2 = data.Add2;
  dto_Merchant.Add3 = data.Add3;
  dto_Merchant.ImageURL = data.IL;
  dto_Merchant.IO = data.IO;
  dto_Merchant.ServiceChargePer = data.ServiceChargePer;
  dto_Merchant.ZoneID = data.ZI;
  dto_Merchant.Zone = data.z;
  dto_Merchant.MinBillValue = data.MB;
  dto_Merchant.EstTime = data.ET;
  dto_Merchant.MerchantType = data.MT;
  dto_Merchant.MerchantDeliveryZones = data.MerchantDeliveryZones;
  dto_Merchant.MaxBillValue = data.MX;
  dto_Merchant.DineType = data.DineType;
  dto_Merchant.BannerURL = data.BannerURL;
  dto_Merchant.CSP = data.CSP;
  dto_Merchant.RegionID = data.RI;
  dto_Merchant.DeliveryRange = data.DR;
  dto_Merchant.CountryCode = data.CC;
  dto_Merchant.Location = data.LC;
  dto_Merchant.ContactNo = data.CN;
  dto_Merchant.OpeningHours = data.OH;
  dto_Merchant.AllowScheduledOrder = data.ASO;
  dto_Merchant.NoOfDaysScheduledOrders = data.NOD;
  dto_Merchant.ScheduledOrderMerchantDisplayTime =
    data.ScheduledOrderMerchantDisplayTime;
  dto_Merchant.AllowInstanceOrder = data.AllowInstanceOrder;
  dto_Merchant.TotalOrders = data.TO;
  dto_Merchant.PrimarydeliveryRange = data.PDR;
  dto_Merchant.PrimaryRangeDeliveryTime = data.PRDT;
  dto_Merchant.PayMode = data.PM;
  dto_Merchant.BankTransferAccountDetails = data.BTA;
  dto_Merchant.MobileAppUIType = data.MobileAppUIType;
  dto_Merchant.TotalProducts = data.TotalProducts;
  dto_Merchant.EstDeliveryCharges = data.EstDeliveryCharges;
  dto_Merchant.MerchantStatus = data.MS;
  dto_Merchant.MerchantPromoText = data.MerchantPromoText;
  dto_Merchant.ProductBannerUrl = data.ProductBannerUrl;
  dto_Merchant.IPGUrl = data.IPGUrl;
  dto_Merchant.IPGUsername = data.IPGUsername;
  dto_Merchant.IPGPassword = data.IPGPassword;
  dto_Merchant.IPGMerchantNumber = data.IPGMerchantNumber;
  dto_Merchant.IsMerchantCancelOrder = data.IsMerchantCancelOrder;
  dto_Merchant.MAXOrderRecivedCount = data.MOR;
  dto_Merchant.CurrentOrderCount = data.COC;
  dto_Merchant.RefMID = data.RefMID;
  dto_Merchant.RefMerchant = data.RefMerchant;
  dto_Merchant.PackingCharge = data.PC;
  await set_dto_selected_merchant_or_product(data);
};
//#endregion

//#region dto-StartupPageLoadInfo
export const set_dto_StartupPageLoadInfo = async (data) => {
  let cordinates = data.DefaultLocation.split(",");
  var PhoneNoDetails = JSON.parse(data.PhoneNoDetails).split("μ");

  let Currency = data.Currency;
  if (Currency.includes('"')) {
    Currency = JSON.parse(data.Currency);
  }

  dto_StartupPageLoadInfo.SingleAdvertURL = data.SingleAdvertURL;
  dto_StartupPageLoadInfo.isMobileGpsEnabled = data.isMobileGpsEnabled;
  dto_StartupPageLoadInfo.dtoZoneList = data.dtoZoneList;
  dto_StartupPageLoadInfo.isMobileAddressMap = data.isMobileAddressMap;
  dto_StartupPageLoadInfo.PhoneNoDetails = data.PhoneNoDetails;
  dto_StartupPageLoadInfo.Currency = Currency;
  dto_StartupPageLoadInfo.isLoadQrCode = data.isLoadQrCode;
  dto_StartupPageLoadInfo.ContactUs = data.ContactUs;
  dto_StartupPageLoadInfo.AdvertisementUrl = data.AdvertisementUrl;
  dto_StartupPageLoadInfo.PayModeTypes = data.PayModeTypes;
  dto_StartupPageLoadInfo.DefaultLocation = data.DefaultLocation;
  dto_StartupPageLoadInfo.AppBlock = data.AppBlock;
  dto_StartupPageLoadInfo.isPromoEnabled = data.isPromoEnabled;
  dto_StartupPageLoadInfo.isDineTypeButtonCall = data.isDineTypeButtonCall;
  dto_StartupPageLoadInfo.isRiderOrderCancel = data.isRiderOrderCancel;
  dto_StartupPageLoadInfo.isRiderDeliveryPath = data.isRiderDeliveryPath;
  dto_StartupPageLoadInfo.isRiderReportsDisplay = data.isRiderReportsDisplay;
  dto_StartupPageLoadInfo.BankTransferAccountDetails =
    data.BankTransferAccountDetails;
  dto_StartupPageLoadInfo.HomePageBackgroundImageUrl =
    data.HomePageBackgroundImageUrl;
  dto_StartupPageLoadInfo.isManualAddressVisible = data.isManualAddressVisible;
  dto_StartupPageLoadInfo.AllowScheduledOrders = data.AllowScheduledOrders;
  dto_StartupPageLoadInfo.ScheduledOrderTimeGap = data.ScheduledOrderTimeGap;
  dto_StartupPageLoadInfo.DefaultDineType = data.DefaultDineType;
  dto_StartupPageLoadInfo.isDisplayAllMerchantTypes =
    data.isDisplayAllMerchantTypes;
  dto_StartupPageLoadInfo.MerchantProductPricePer =
    data.MerchantProductPricePer;
  dto_StartupPageLoadInfo.IOSAllowLocationPermission =
    data.IOSAllowLocationPermission;
  dto_StartupPageLoadInfo.isTrackAnalytics = data.isTrackAnalytics;
  dto_StartupPageLoadInfo.isDisplayEstDeliveryCharges =
    data.isDisplayEstDeliveryCharges;
  dto_StartupPageLoadInfo.DisplayDineType = data.DisplayDineType;
  dto_StartupPageLoadInfo.isDisplayInvDownloadButton =
    data.isDisplayInvDownloadButton;
  dto_StartupPageLoadInfo.isDisplayRecommendation =
    data.isDisplayRecommendation;
  dto_StartupPageLoadInfo.IsEnableGoogleMapsSearch =
    data.IsEnableGoogleMapsSearch;
  dto_StartupPageLoadInfo.GoogleMapsAPIKey = data.GoogleMapsAPIKey;
  dto_StartupPageLoadInfo.AppTimeout = data.AppTimeout;
  dto_StartupPageLoadInfo.DisplayCustomerNotification =
    data.DisplayCustomerNotification;
  dto_StartupPageLoadInfo.CheckCustomerSignout = data.CheckCustomerSignout;
  dto_StartupPageLoadInfo.SharingUrl = data.SharingUrl;
  dto_StartupPageLoadInfo.isDisplayLoyaltyPoints = data.isDisplayLoyaltyPoints;
  dto_StartupPageLoadInfo.isDisplaySignOut = data.isDisplaySignOut;
  dto_StartupPageLoadInfo.DefaultLat = parseFloat(cordinates[0]);
  dto_StartupPageLoadInfo.DefaultLong = parseFloat(cordinates[1]);
  dto_StartupPageLoadInfo.CountryPhoneCode = parseInt(PhoneNoDetails[0]);
  dto_StartupPageLoadInfo.CountryPhoneLength = parseInt(PhoneNoDetails[1]);
  dto_StartupPageLoadInfo.CountryFlag = PhoneNoDetails[2];
  dto_StartupPageLoadInfo.IsMLProduct = data.IsMLProduct;
  await SET_STORE_MOBILE_SETTINGS();
};
//#endregion

//#region dto-MobileAppCategory
export const set_dto_MobileAppCategory = async (data) => {
  dto_MobileAppCategory.BusinessType = data.BusinessType;
  dto_MobileAppCategory.CountryCode = data.CC;
  dto_MobileAppCategory.CSP = data.CSP;
  dto_MobileAppCategory.MACID = data.MACID; //data.MD;
  dto_MobileAppCategory.MACImageUrl = data.MACImageUrl;
  dto_MobileAppCategory.MACOrder = data.MACOrder;
  dto_MobileAppCategory.MobileAppCategory = data.MobileAppCategory;
  dto_MobileAppCategory.ListType = data.ListType; // ZEENA
  await SET_STORE_MOBILE_APP_CATEGORY();
};
//#endregion

//#region dto-selected-merchant-or-product
export const set_dto_selected_merchant_or_product = async (data) => {
  dto_selected_merchant_or_product.PID = data.PI;
  dto_selected_merchant_or_product.Code = data.Code;
  dto_selected_merchant_or_product.Description = data.D;
  dto_selected_merchant_or_product.GDescription = data.G;
  dto_selected_merchant_or_product.UP = data.P;
  dto_selected_merchant_or_product.UD = data.UD;
  dto_selected_merchant_or_product.CATID = data.CATID;
  dto_selected_merchant_or_product.IsAvailable = data.A;
  dto_selected_merchant_or_product.ProductImageUrl = data.IU;
  // dto_selected_merchant_or_product.ProductGroupId = data.PG;
  dto_selected_merchant_or_product.MaxQty = data.Q;
  dto_selected_merchant_or_product.MID = data.MID;
  dto_selected_merchant_or_product.Merchant = data.Merchant;
  dto_selected_merchant_or_product.ImageURL = data.IL || data.ImageURL || "";
  dto_selected_merchant_or_product.IO = data.IO;
  dto_selected_merchant_or_product.MinBillValue = data.MB;
  dto_selected_merchant_or_product.MaxBillValue = data.MX;
  dto_selected_merchant_or_product.MobileAppUIType = data.MobileAppUIType;
  dto_selected_merchant_or_product.ASO = data.ASO; //h
  dto_selected_merchant_or_product.AllowInstanceOrder = data.AllowInstanceOrder;
  dto_selected_merchant_or_product.MT = data.MT;
  dto_selected_merchant_or_product.ZoneID = dto_common.ZI;
  dto_selected_merchant_or_product.DineType = data.DineType; //ZEENA
  dto_selected_merchant_or_product.Zone = dto_common.ZoneDescription;
  await SET_STORE_SELECTED_MERCHANT_PRODUCT();
};
//#endregion

//#region dto-selected-merchant-or-product
export const set_dto_selected_final_merchant_or_product = async (data) => {
  dto_selected_final_merchant_or_product.PID = data.PI;
  dto_selected_final_merchant_or_product.Code = data.Code;
  dto_selected_final_merchant_or_product.Description = data.D;
  dto_selected_final_merchant_or_product.GDescription = data.G;
  dto_selected_final_merchant_or_product.UP = data.P;
  dto_selected_final_merchant_or_product.UD = data.UD;
  dto_selected_final_merchant_or_product.CATID = data.CATID;
  dto_selected_final_merchant_or_product.IsAvailable = data.A;
  dto_selected_final_merchant_or_product.ProductImageUrl = data.IU;
  // dto_selected_final_merchant_or_product.ProductGroupId = data.PG;
  dto_selected_final_merchant_or_product.MaxQty = data.Q;
  dto_selected_final_merchant_or_product.MID = data.MID;
  dto_selected_final_merchant_or_product.Merchant = data.Merchant;
  dto_selected_final_merchant_or_product.ImageURL =
    data.IL || data.ImageURL || "";
  dto_selected_final_merchant_or_product.IO = data.IO;
  dto_selected_final_merchant_or_product.MinBillValue = data.MB;
  dto_selected_final_merchant_or_product.MaxBillValue = data.MX;
  dto_selected_final_merchant_or_product.MobileAppUIType = data.MobileAppUIType;
  dto_selected_final_merchant_or_product.AllowScheduledOrder = data.ASO;
  dto_selected_final_merchant_or_product.AllowInstanceOrder =
    data.AllowInstanceOrder;
  dto_selected_final_merchant_or_product.MT = data.MT;
  dto_selected_final_merchant_or_product.DineType = data.DineType;
  dto_selected_final_merchant_or_product.ZoneID = dto_common.ZoneId;
  dto_selected_final_merchant_or_product.Zone = dto_common.ZoneDescription;
  await SET_STORE_CART_SELECT_MERCHATS_ZONE(
    dto_selected_final_merchant_or_product
  );
};
//#endregion

//#region CartDataAfterCalculation
export const set_dto_checkout_data_from_calculation_service = async (data) => {
  const findByKey = (key) =>
    data.find((item) => item && item.hasOwnProperty(key));

  const grandTotal = findByKey("GrandTotal");
  const totalTax = findByKey("TotalTax");
  const serviceCharge = findByKey("TotalServiceCharge");
  const docDiscount = findByKey("DocDiscountTotal");
  const rowDiscount = findByKey("RowDiscountTotal");
  const subTotal = findByKey("NonDisplaySubTotal");
  const discountPercent = findByKey("DiscountPercentage");
  const promoGuid = findByKey("PromoGUID");
  const promoCode = findByKey("PromoCode");
  const promoHeader = findByKey("PromoHeader");
  const xmlTaxDoc = findByKey("XMLTaxDoc");
  const ipgUrl = findByKey("IPGUrl");
  const ipgUsername = findByKey("IPGUsername");
  const ipgPassword = findByKey("IPGPassword");
  const ipgMerchant = findByKey("IPGMerchantNumber");
  const payMode = findByKey("PayMode");
  const bankTransfer = findByKey("BankTransferAccountDetails");

  dto_cart_checkout.Cart = data[0][0];
  dto_cart_checkout.Total =
    grandTotal?.GrandTotal?.replace(/[^0-9.-]+/g, "") || "";
  dto_cart_checkout.TaxTotal =
    totalTax?.TotalTax?.replace(/[^0-9.-]+/g, "") || "";
  dto_cart_checkout.ServiceCharge =
    serviceCharge?.TotalServiceCharge?.replace(/[^0-9.-]+/g, "") || "";
  dto_cart_checkout.DiscountTotal =
    docDiscount?.DocDiscountTotal?.replace(/[^0-9.-]+/g, "") || "";
  dto_cart_checkout.RowDiscountTotal =
    rowDiscount?.RowDiscountTotal?.replace(/[^0-9.-]+/g, "") || "";
  dto_cart_checkout.SubTotal =
    subTotal?.NonDisplaySubTotal?.replace(/[^0-9.-]+/g, "") || "";
  dto_cart_checkout.DiscountPersentage = discountPercent?.DiscountPercentage;
  dto_cart_checkout.PromoGuid = parseInt(promoGuid?.PromoGUID || 0);
  dto_cart_checkout.PromoCODE = promoCode?.PromoCode;
  dto_cart_checkout.PromoHeader = promoHeader?.PromoHeader;
  dto_cart_checkout.XMLTaxDoc = xmlTaxDoc?.XMLTaxDoc;
  dto_cart_checkout.IPGUrl = ipgUrl?.IPGUrl;
  dto_cart_checkout.IPGUsername = ipgUsername?.IPGUsername;
  dto_cart_checkout.IPGPassword = ipgPassword?.IPGPassword;
  dto_cart_checkout.IPGMerchantNumber = ipgMerchant?.IPGMerchantNumber;
  dto_cart_checkout.PayModeTypes = payMode?.PayMode;
  dto_cart_checkout.BankTransferAccountDetails = bankTransfer?.BankTransferAccountDetails;
  SET_STORE_CART_CHECKOUT_DATA(dto_cart_checkout);
};
//#endregion

//#region dto_checkout_data_store
export const set_dto_checkout_data_store = async (data) => {
  dto_cart_checkout.Cart = data.Cart;
  dto_cart_checkout.Total = data.Total;
  dto_cart_checkout.TaxTotal = data.TaxTotal;
  dto_cart_checkout.ServiceCharge = data.ServiceCharge;
  dto_cart_checkout.DiscountTotal = data.DiscountTotal;
  dto_cart_checkout.RowDiscountTotal = data.RowDiscountTotal;
  dto_cart_checkout.SubTotal = data.SubTotal;
  dto_cart_checkout.DiscountPersentage = data.DiscountPersentage;
  dto_cart_checkout.PromoGuid = data.PromoGuid;
  dto_cart_checkout.PromoCODE = data.PromoCODE;
  dto_cart_checkout.PromoHeader = data.PromoHeader;
  dto_cart_checkout.XMLTaxDoc = data.XMLTaxDoc;
  dto_cart_checkout.IPGUrl = data.IPGUrl;
  dto_cart_checkout.IPGUsername = data.IPGUsername;
  dto_cart_checkout.IPGPassword = data.IPGPassword;
  dto_cart_checkout.IPGMerchantNumber = data.IPGMerchantNumber;
  dto_cart_checkout.PayModeTypes = data.PayModeTypes;
  dto_cart_checkout.BankTransferAccountDetails =
    data.BankTransferAccountDetails;
  SET_STORE_CART_CHECKOUT_DATA(dto_cart_checkout);
};
//#endregion
